import React from 'react'
import {
  Router,
  Route,
} from 'react-router-dom'
import { toast } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'

import KioskApp from './kiosk/App'

import { customHistory } from './stores'

import AppRoutes from './AppRoutes'
import ErrorBoundary from './ErrorBoundary'

import { setErrorInfo } from './actions/appState'

const App = () => {
  const dispatch = useDispatch()

  const handleError = (error) => {
    // Show a toast to the user
    toast.error('An unexpected error occurred. Please try again later.', {
      position: toast.POSITION.BOTTOM_RIGHT
    });

    /* 
    Should redirect to kiosk menu-selection/menu if in kiosk mode, 
    user-login if in concessions and attendants exist, 
    concessions menu if no attendants exist,
    and to configuration if no app mode is selected,
    */
    customHistory.push('/');

    if (error && typeof error.preventDefault === 'function') {
      dispatch(setErrorInfo({
        message: error.message,
        stack: error.stack
      }))
      error.preventDefault();
    }
  }

  window.onerror = handleError;
  window.addEventListener('error', handleError);

  return (
      <Router history={customHistory}>
        <ErrorBoundary handleError={handleError}>
          <AppRoutes />
          <Route path="/kiosk" component={KioskApp} />
        </ErrorBoundary>
      </Router>
  )
}

export default App
